import React, { useContext, useState } from 'react';
import { Timeout } from '../../functions/functions';
import { ShowAdsInfoContext } from './types';
import ButtonsForm from '../../HtmlComponents/ButtonsForm';
import { useDispatch } from 'react-redux';
import { DeleteAdsInfoApi } from '../../redux/adsinfo/adsInfoApiCalls';
import ShowErrorMsg from '../../HtmlComponents/ShowErrorMsg';

interface props {
  modal: boolean, 
  toggle: any
}

const DeleteAdsInfoModal: React.FC<props> = ({ modal, toggle }) => {
  const [loading, setLoading] = useState(false)
  const dispatch: any = useDispatch()
  const [errors, setErrors] = useState<string[]>([])
  const { setShowSuccessMsg, selectedAdsInfo } = useContext(ShowAdsInfoContext)

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    setLoading(true)
    try {
      const response: any = await dispatch(DeleteAdsInfoApi(selectedAdsInfo._id))
      if(response === true) {
        toggle()
        setShowSuccessMsg(true)
        setTimeout(() => setShowSuccessMsg(false), Timeout)
      } else {
        setErrors(response)
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
    {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-md shadow-lg">
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmit}
                    encType="multipart/form-data"                  
                  >
                    <ShowErrorMsg errors={errors} setErrors={setErrors} />
                    <ButtonsForm loading={loading} typeBtn='Supprimer' toggle={toggle} />
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default DeleteAdsInfoModal
